<fa-icon [icon]="userIcon" class="userShortInfo"></fa-icon>{{ userShortInfo?.displayName }}
